<style lang="scss" scoped>
.home {
  padding: 0;
  margin-top: -10px;

  ::v-deep .el-card__body {
    padding-bottom: 10px;
  }
}




.ys_icon{
  font-size:30px;
  color:#dfdfdf;
}
</style>

<template>
  <div class="home">
	
    <!-- <l-auth auth="c_home_show">
      <l-c-home></l-c-home>
    </l-auth>

    <l-auth auth="mt_home_show">
      <l-mt-home ></l-mt-home>
    </l-auth> -->
    <div class="mg_10">
      <h1>数据统计</h1>
    </div>
    <el-row>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_success flex justify-between items-center">
          <div>
            <p class="title">培训项目总数</p>
            <p>{{place_count}}</p>
          </div>
          <i class="el-icon-success ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_primary flex justify-between items-center">
          <div>
            <p class="title">培训分项数</p>
            <p>{{material_type_count}}</p>
          </div>
          <i class="el-icon-circle-plus ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_primary flex justify-between items-center">
          <div>
            <p class="title">培训总时长</p>
            <p>{{material_quantity}}</p>
          </div>
          <i class="el-icon-circle-plus ys_icon"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="mg_10">
          <div class="ys_box ys_left_border_error flex justify-between items-center">
          <div>
            <p class="title">待审批培训项目数量</p>
            <p>{{place_wait_count}}</p>
          </div>
          <i class="el-icon-warning ys_icon"></i>
          </div>
        </div>
      </el-col>

      <!-- <el-row>
        <el-col :span="14">
          <div class="mg_10">  
          <div class="ys_chart">
            <div class="ys_chart_title">
              <span>
              数量统计</span>
            </div>
            <div class="ys_chart_box">
              <linechart :list="list"/>
            </div>
          </div>
          </div>
        </el-col>
        
        <el-col :span="12">
          <div class="mg_10">  
          <div class="ys_chart">
              <div class="ys_chart_title">
                <span>培训项目社区分布图示</span>
              </div>
            <div class="ys_chart_box">
              <piechart :charId="char1" :charTitle="charTitle1" :charData="charData"/>
            </div>
          </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="mg_10">  
          <div class="ys_chart">
              <div class="ys_chart_title">
                <span>培训分项分类管理图示</span>
              </div>
            <div class="ys_chart_box">
              <piechart2 :charId="char2" :charTitle="charTitle2" :charData="charData2"/>
            </div>
          </div>
          </div>
        </el-col>
      </el-row> -->
    </el-row>
  </div>
</template>

<script>
// import CHome from "./CHome";
// import MtHome from "./MtHome";
import linechart from "@/components/chart/linechart";
import timechart from "@/components/chart/timechart";
import piechart from "@/components/chart/piechart";
import piechart2 from "@/components/chart/piechart2";
export default {
  name: "home",
  components: {
    // [CHome.name]: CHome,
    // [MtHome.name]: MtHome,
    linechart,
    timechart,
    piechart,
    piechart2,
  },

  data() {
    return {
      loading: false,
      place_count:0,
      place_wait_count:0,
      material_type_count:0,
      material_quantity:0,
      place_new_count:0,
      hidden_count:0,
      hidden_new_count:0,
      list:[],
      charTitle1: "社区分布图示",
      charTitle2: "分项分类图示",
      charData:{},
      charData2:{},
    };
  },

  mounted() {
    //   this.companyChart();
    //   this.taskCharg();
    //   this.userRoleChart();
    this.getList();
  },
  methods:{
    getList(){
      this.$_invoke(`home_getData`).then((res) => {
        res=res.data
        this.place_count=res.place_count;
        this.place_wait_count=res.place_wait_count;
        this.material_type_count=res.material_type_count;
        this.material_quantity=res.material_quantity;
        this.place_new_count=res.place_new_count
        this.hidden_count=res.hidden_count
        this.hidden_new_count=res.hidden_new_count
        this.list=res.type_data;
        
        this.charData = [
            {
              value: 10,
              name: "大富社区"
            },
            {
              value: 10,
              name: "库坑社区"
            },
            {
              value: 10,
              name: "桂花社区"
            },
            {
              value: 10,
              name: "桂香社区"
            },
            {
              value: 10,
              name: "新澜社区"
            },
            {
              value: 10,
              name: "黎光社区"
            },
            {
              value: 10,
              name: "君子布社区"
            },
            {
              value: 10,
              name: "大水田社区"
            },
            {
              value: 10,
              name: "广培社区"
            },
            {
              value: 10,
              name: "牛湖社区"
            }
        ];
        this.charData = res.charData;
        
        this.charData2 = [
            {
              value: 10,
              name: "大富社区"
            },
            {
              value: 10,
              name: "库坑社区"
            },
            {
              value: 10,
              name: "桂花社区"
            },
            {
              value: 10,
              name: "桂香社区"
            },
            {
              value: 10,
              name: "新澜社区"
            },
            {
              value: 10,
              name: "黎光社区"
            },
            {
              value: 10,
              name: "君子布社区"
            },
            {
              value: 10,
              name: "大水田社区"
            },
            {
              value: 10,
              name: "广培社区"
            },
            {
              value: 10,
              name: "牛湖社区"
            }
        ];
        
      });
    }
  }
};
</script>
